import { AfterContentInit, AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core'
import { UserService } from "../../services/user.service"
import { AuthService } from "../../services/auth.service"
import { NavigationEnd, ResolveEnd, Router } from "@angular/router"
import { UserM } from "../../model/user.model"
import { PermissionM } from "../../model/permission.model"
import swal from "sweetalert2"
import { HeaderService } from "../../services/header.service"
declare var require: any

@Component({
  selector: 'ap-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit, AfterContentInit, OnDestroy {
  ngOnDestroy(): void {
    if (this.subscribeHeader) {
      this.subscribeHeader.unsubscribe()
    }

  }


  branch_id = 1
  showBranch = true
  adminUsers: Array<UserM> = []
  show = true
  currentAdmin = new UserM()
  showMiniSidebar = false
  subscribeHeader
  logo = require("../../../assets/images/logo-276.png")
  logo_collapse = require("../../../assets/images/logo-short.png")
  title = ""

  constructor(private userService: UserService, private authService: AuthService, private router: Router, private renderer: Renderer2, private el: ElementRef, private headerService: HeaderService) {
    router.events.filter((event) => event instanceof ResolveEnd)
      .subscribe((event) => {
        var path = event['url']
        var chatPath = "/signin"
        if (path.indexOf("/form") > -1) {
          this.showBranch = true
        } else {
          this.showBranch = true
        }
      })

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        var url = this.getPathFromEventUrl(evt.url)
        if (['/', '/authen/signin'].indexOf(url) > -1) {
          this.show = this.isAuth()
        } else {
          this.show = true
        }
      }
    })
  }

  ngOnInit(): void {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    this.currentAdmin = { ...currentUser }
    this.userService.subscribeShowBranchOnNavigation().subscribe(show => {
      this.showBranch = show
    })

    this.subscribeHeader = this.headerService.notifyObservable$.subscribe(res => {
      if (res.action === "setTitle") {
        if (res.title) {
          var limit = 90
          var trunc = (res.title.length > limit) ? '...' : ''
          Promise.resolve(null).then(() => {
            this.title = `${res.title.substr(0, limit)}${trunc}`
          })
        }
      }
    })

    this.userService.getAllUser('admin').subscribe(res => {
      res.results.forEach((item, index) => {
        this.adminUsers.push(item)
      })
      var x = 0
    })
  }

  ngAfterContentInit() {

  }

  setBranch(branch_idN: number) {
    this.branch_id = branch_idN
    this.userService.setBranch(this.branch_id).subscribe(res => {
      this.userService.triggerChangeBranch(this.branch_id)
    })
  }

  signout() {
    localStorage.removeItem('currentUser')
    this.router.navigate([`/authen/signin`])
  }

  toggleSidebar() {
    this.showMiniSidebar = !this.showMiniSidebar
    if (this.showMiniSidebar) {
      this.renderer.addClass(document.body, 'mini-sidebar')
    } else {
      this.renderer.removeClass(document.body, 'mini-sidebar')

    }
  }

  changeAdmin(user: UserM) {
    this.currentAdmin = user
    this.userService.changeAdmin(user.id).subscribe(res => {
      if (res.data) {
        localStorage.setItem('currentUser', JSON.stringify(res.data.user))
        let message = `Admin changed to ${user.firstname}`
        swal(message, "changed successfully", "success").then(value => {
          if (value) {
            //location.reload()

            this.headerService.notifyRefresh()
          }
        })
      }
    })
  }

  isAuth() {
    var userN = localStorage.getItem('currentUser')
    var user = JSON.parse(userN)
    return !!(user)
  }

  getPathFromEventUrl(eventUrl) {
    var urlA = eventUrl.split('?')
    if (urlA.length > 1) {
      return urlA[0]
    } else {
      return eventUrl
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/header-navigation/navigation.component.ts